import _ from '@luna/lodash';
import type { COUNTRY } from '@shared/core-types';

import type { CardReservationFeatures } from '../types/CardReservationFeatures';
import { cards as base } from './base';
import { cards as AT } from './countries/AT';
import { cards as CZ } from './countries/CZ';
import { cards as HR } from './countries/HR';
import { cards as HU } from './countries/HU';
import { cards as RO } from './countries/RO';
import { cards as SK } from './countries/SK';

export const cardReservationsFeatures: Record<COUNTRY, CardReservationFeatures> = {
    AT: _.merge({}, base, AT),
    CZ: _.merge({}, base, CZ),
    HR: _.merge({}, base, HR),
    HU: _.merge({}, base, HU),
    RO: _.merge({}, base, RO),
    SK: _.merge({}, base, SK),
    RS: _.merge({}, base, {}),
};
